import styled from 'styled-components';
import { deviceMaxWidth, style } from 'utils/constants/style';

export const Wrapper = styled.div`
  width: -webkit-fill-available;
`;

export const HeaderWrapper = styled.div`
display:flex;
width: 550px;
justify-content:space-between;
@media only screen and (${deviceMaxWidth.sm}) {
    width: 100%;
    max-width: 550px;
    & > div {
      &:nth-child(2) {
        width: 100% !important;
      }
    }
  }
`;

export const Header = styled.h4``;

export const PostWrapper = styled.div``;

export const ShowPinnedPostContainer = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 5px;
`;
export const ShowPinnedPostButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 5px;
`;
export const ShowPinnedText= styled.span`
font-size:14px;
color:${style.mainBlue.blue};
margin-right:5px;
cursor:pointer;
`